import styled from "styled-components";

export const GamificationModalSubtitleContainer = styled.p`
  font: 400 1rem/1.5rem "Inter";
  color: ${({ theme }) => theme.console.pageTitleColor};
  text-align: center;

  margin-bottom: 1.875rem;
`;
